import _ from "lodash";
import { useEffect, useState } from "react";

import logo from "./logo.svg";
import "./App.css";

import { getAvailableTokens } from "./web3/art4n";
import { usePromise } from "./web3/utils";

import Gallery from "./Gallery";
import {
  shapes,
  rectangles,
  gradients,
  squares,
  rotations,
  strokes,
} from "./filterOptions";
import { Select } from "./Select";
import n from "./n.json";

const filterVariant = (variant: any, filteredData: any) =>
  filteredData.filter((d: any) =>
    variant.value.values.includes(
      (n as any)[Number(d) - 1][`number_${variant.value.n}`]
    )
  );

function App() {
  const { data, loading } = usePromise(getAvailableTokens);
  const [page, setPage] = useState(1);

  console.log(data);

  const [shape, setShape] = useState<any>();
  const [gradient, setGradient] = useState<any>();
  const [rotation, setRotation] = useState<any>(rotations[0]);
  const [square, setSquare] = useState<any>();
  const [stroke, setStroke] = useState<any>();
  const [nrOfRectangles, setNrOfRectangles] = useState<any>();

  let filteredData: string[] = data?.data ?? [];

  if (shape) {
    filteredData = filterVariant(shape, filteredData);
  }
  if (nrOfRectangles) {
    filteredData = filterVariant(nrOfRectangles, filteredData);
  }
  if (gradient) {
    filteredData = filterVariant(gradient, filteredData);
  }
  if (rotation) {
    filteredData = filterVariant(rotation, filteredData);
  }
  if (square) {
    filteredData = filterVariant(square, filteredData);
  }
  if (stroke) {
    filteredData = filterVariant(stroke, filteredData);
  }

  const tokens = _.chunk(filteredData, 25);

  useEffect(() => {
    if (page > tokens?.length) {
      setPage(1);
    }
  }, [tokens?.length, page]);

  return (
    <div className="App">
      <header className="App-header">
        {loading && (
          <div>
            <img src={logo} className="App-logo" alt="logo" />
            <p>Loading...</p>
          </div>
        )}
        <h2>Art For N unminted artworks</h2>
        <a
          style={{ color: "white", fontSize: 18, marginBottom: 8 }}
          target="_blank"
          href="https://twitter.com/art_4_N/status/1435996364748509187"
          rel="noreferrer"
        >
          Mint instructions
        </a>
        <a
          style={{ color: "white", fontSize: 18 }}
          target="_blank"
          rel="noreferrer"
          href="https://etherscan.io/address/0xB2Ee306F1C8D314341b7C335014473aa8C2D5D71#writeContract"
        >
          Contract
        </a>

        <div
          style={{
            paddingLeft: 48,
            paddingRight: 48,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          <Select
            label="Shape"
            options={shapes}
            value={shape}
            setValue={setShape}
          />
          <Select
            label="Rects"
            options={rectangles}
            value={nrOfRectangles}
            setValue={setNrOfRectangles}
          />
          <Select
            label="Gradient"
            options={gradients}
            value={gradient}
            setValue={setGradient}
          />
          <Select
            label="Rotation"
            options={rotations}
            value={rotation}
            setValue={setRotation}
          />
          <Select
            label="Only Squares"
            options={squares}
            value={square}
            setValue={setSquare}
          />
          <Select
            label="Stroke"
            options={strokes}
            value={stroke}
            setValue={setStroke}
          />
        </div>
        {!loading && <h3>{filteredData.length} left</h3>}
        {loading && <h3>Loading...</h3>}
        <Gallery tokens={tokens[page - 1] ?? []} />
        <div style={{ flexDirection: "row", flexWrap: "wrap" }}>
          {tokens.map((__, idx) => {
            return (
              <button
                style={{ marginRight: 4 }}
                key={idx}
                onClick={() => {
                  setPage(idx + 1);
                  document.body.scrollTop = 0;
                  document.documentElement.scrollTop = 0;
                }}
              >
                {idx + 1}
              </button>
            );
          })}
        </div>
      </header>
    </div>
  );
}

export default App;
